import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
import { Content_ProviderCommonFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderCommonFragment.generated'
import { Content_ProviderMetadataFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderMetadataFragment.generated'
export type YiHomepageHero_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  language?: string | null
  primaryLanguage?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  title?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiHomepageHeroContent?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      title?: string | null
      published?: boolean | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: Types.ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export const YiHomepageHero_ContentFragmentFragmentDoc = gql`
  fragment YIHomepageHero_ContentFragment on Content {
    id
    contentId
    contentType
    language
    primaryLanguage
    published
    publishedAtDate
    title
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiHomepageHeroContent: contentReferencesFrom(types: "yi-homepage-hero-content") {
      id
      contentReferenceType {
        type
      }
      contentTo {
        id
        contentType
        contentId
        title
        published
        yiContentType: contentReferencesFrom(types: "yi-content-type") {
          ...ContentDetails_Tag_ContentReferenceFragment
        }
        contentProvider {
          provider
          providerKey
          ...Content_ProviderCommonFragment
        }
      }
    }
    ...Content_ProviderMetadataFragment
  }
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${Content_ProviderCommonFragmentFragmentDoc}
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
